import {gsap} from "../../libs/gsap/all.js";
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';

// Constructor
export class PlayerAudio extends PIXI.Container {

  constructor() {
    super();

    this.sound = null;
    this.soundPlaying = false;
    this.soundVolume = {value: 0};
    this.fadeDuration = 0.5; // sec

    this.build();
  }

  build() {

    this.sound = new Howl({
      src: [app.data.global.sounds.player_idle],
      loop: true,
      autoplay: false,
      volume: 0,
    });

  }

  start(audioFadeIn = true) {
    this.playAudio(audioFadeIn);
  }

  stop(audioFadeOut = true) {
    this.stopAudio(audioFadeOut);
  }

  playAudio(fadeIn = true) {
    if (!this.soundPlaying) {
      this.soundPlaying = true;

      if (fadeIn) {
        this.sound.play();

        gsap.to(this.soundVolume, {
          value: 1,
          duration: this.fadeDuration,
          ease: "quad.in",
          overwrite: "auto",
          onUpdate: () => {
            this.sound.volume(this.soundVolume.value);
          },
          onComplete: () => {
          }
        })
      } else {
        this.sound.play();
        this.sound.volume(1);
      }
    }
  }

  stopAudio(fadeOut = true) {
    if (this.soundPlaying) {

      if (fadeOut) {
        gsap.to(this.soundVolume, {
          value: 0,
          duration: this.fadeDuration,
          ease: "quad.in",
          overwrite: "auto",
          onUpdate: () => {
            try {
              this.sound.volume(this.soundVolume.value);
            } catch (e) {

            }
          },
          onComplete: () => {
            this.soundPlaying = false;
          }
        })
      } else {
        this.soundVolume.value = 0;
        this.sound.volume(0).stop().seek(0);
      }
    }
  }


  reset() {
    this.stop();
  }


}
